<script>
  import {_} from 'svelte-i18n';
  import {goBack} from "../../../helpers";

  const isMobileApp = JSON.parse(localStorage.getItem('from_mobile')) === true;
</script>

<section>
  <div class="image" />
  <div class="content">
    <h1>{$_('oops')}</h1>
    <p>
      {$_('pageMissing')}
    </p>
    <button type="button" on:click={() => goBack(isMobileApp)}>{$_('Back')}</button>
  </div>
</section>

<style lang="scss">
  * {
    box-sizing: border-box;
  }

  section {
    display: grid;
    grid-template-columns: 343px 1fr;
    grid-gap: 16px;
    max-width: 1070px;
    width: 100%;
    box-shadow: 0 2px 8px 0 #10107A29;
    border-radius: 16px;
    overflow: hidden;
    margin: 40px auto;

    @media (max-width: 1201px) {
      max-width: 942px;
    }

    @media (max-width: 768px) {
      margin: 24px;
      width: auto;
    }

    @media (max-width: 700px) {
      grid-template-columns: 1fr;
      margin: 15px;
      gap: 0;
    }

    .image {
      background: url('/static/404-image.jpg') no-repeat center/cover;
      
      @media (max-width: 700px) {
        height: 373px;
      }

      @media (max-width: 500px) {
        height: 200px;
      }
    }

    .content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 39px 16px;

      @media (max-width: 700px) {
        padding: 16px;
        text-align: center;
      }

      h1 {
        font-size: 30px;
        font-weight: 600;
        line-height: 39px;
        color: #22252C;
        margin: 0;

        @media (max-width: 500px) {
          font-size: 20px;
          line-height: 29px;
        }
      }

      p {
        color: #22252C;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        margin: 0 !important;
        padding: 0 !important;
        margin-top: 4px !important;

        @media (max-width: 500px) {
          font-size: 14px;
          line-height: 20px;
        }
      }

      button {
        margin-top: 16px;
        border: none;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: white;
        background-color: #576CED;
        padding: 14px 12px 14px 12px;
        border-radius: 30px;
        align-self: baseline;
        width: 220px;
        cursor: pointer;

        @media (max-width: 700px) {
          margin: 0 auto;
          margin-top: 16px;
        }
      }
    }
  }
</style>